<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
export default {
  name: 'App',
};
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
    color: #333333;
  }

  body, div, ul, ol, li, dl, dt, dd, h1, h2, h3, h4, h5, h6, form, input, textarea, p, a {
    margin: 0px;
    padding: 0px;
    font-family: 'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', 'Hiragino Sans GB', tahoma, arial, sans-serif;
  }

  ul, ol {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  .f-cb:after, .f-cbli li:after {
    display: block;
    clear: both;
    visibility: hidden;
    height: 0;
    overflow: hidden;
    content: ".";
  }
  /*滚动条样式*/
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: transparent;
    border-radius: 20px;
  }

  /*滚动条样式*/
  ::-webkit-scrollbar-track-piece{width:8px;background-color:#f0f0f0;border-radius: 5px;}
  ::-webkit-scrollbar{width:8px;background-color:#f7b515;border-radius: 5px;}
  ::-webkit-scrollbar-thumb{width:8px;background-color:#282828;border-radius: 5px;}
  ::-webkit-scrollbar-thumb:hover{width:8px;background-color:#f7b515;border-radius: 5px;}

</style>



// WEBPACK FOOTER //
// src/App.vue